import moment from 'moment-timezone';
import { ToolLike } from 'app/types/tool';
import { ToolStatusFilter } from 'constants/tool';

// A test stays valid for the whole "valid to" day and counts as expired from the next day on.
export const isToolTestExpired = (validTo?: Date | string | null) =>
  !!validTo && moment().isAfter(moment(validTo), 'day');

// Single source of truth for the two halves of the tool status ring (StatusIndicator) and for the
// status column filter of the tools list, so that both always agree.
export const getToolStatus = (tool: ToolLike) => ({
  isMaintenanceOk: tool.LastMaintenanceIsWorking === true,
  isTestOk: tool.LastTestStatus === true && !isToolTestExpired(tool.LastTestValidTo),
});

export const matchesToolStatusFilter = (tool: ToolLike, filter: string | number | boolean) => {
  const { isMaintenanceOk, isTestOk } = getToolStatus(tool);

  switch (filter) {
    case ToolStatusFilter.MaintenanceOk: return isMaintenanceOk;
    case ToolStatusFilter.MaintenanceNotOk: return !isMaintenanceOk;
    case ToolStatusFilter.TestOk: return isTestOk;
    case ToolStatusFilter.TestNotOk: return !isTestOk;
    default: return true;
  }
};
